import styled from 'styled-components';
export const Title = styled.div `
  display: flex;
  width: 100%;
  flex-wrap: wrap;
`;
export const CopyLinkWrapper = styled.div `
  display: block;
  overflow: hidden;
  min-width: 150px;
`;
